
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/self-guided-learning/[slug]/[topicslug]",
      function () {
        return require("private-next-pages/self-guided-learning/[slug]/[topicslug].js");
      }
    ]);
  